export default __webpack_public_path__ + "static/media/adminstration.0dd59ef2.png";